import type { SolutionTrustedLogo } from './types';

export const sharedTrustedLogos: readonly SolutionTrustedLogo[] = [
  { name: 'Tecnolite', src: '/images/home/partners/tecnolite.png', alt: 'Tecnolite' },
  { name: 'Telkom', src: '/images/home/partners/telkom.png', alt: 'Telkom Indonesia' },
  { name: 'SCG', src: '/images/home/partners/scg.png', alt: 'SCG' },
  { name: 'Globe', src: '/images/home/partners/globe.png', alt: 'Globe' },
  { name: 'Calex', src: '/images/home/partners/calex.png', alt: 'Calex Holland' },
  { name: 'Schneider', src: '/images/home/partners/schneider.png', alt: 'Schneider Electric' },
  { name: 'Philips', src: '/images/home/partners/philips.png', alt: 'Philips' },
  { name: 'Haier', src: '/images/home/partners/haier.png', alt: 'Haier' },
];

export const partnerDemoCta = { label: 'Partner With Us', to: '/partner-registration' } as const;
